<!--<p>inmaterial works!</p>-->

<div>
   <!--<app-mapas
    [lat] = "-34.60"
    [lon] = "-58.38"
    [zoom] = "16"
    width = "100%"
    height = "300px"
    >

    </app-mapas>-->

    <app-mapa2
    class="map"
    [center]="[-71.9774868,-13.5169427]"
    [zoom]="15"
    (mapReady)="onMapReady($event)"
    >

    </app-mapa2>
  </div>